// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oV0h","colMin":"styles_colMin__bPCQB"};